import { HAIR_COLORS } from "@/constants/hairColors";

export function parseHairShortlist(value: string | null) {
  const ids = new Set((value || "").slice(0, 300).split(","));
  return [...ids].map(id => HAIR_COLORS.find(color => color.id === id))
    .filter((color): color is (typeof HAIR_COLORS)[number] => !!color).slice(0, 3);
}

export function hairFinderUrl(ids: string[], selected = ids[0]) {
  const shortlist = parseHairShortlist(ids.join(","));
  const shade = shortlist.find(color => color.id === selected) || shortlist[0];
  const params = new URLSearchParams({from: "hair-finder"});
  if (shade) params.set("shade", shade.id);
  if (shortlist.length) params.set("shortlist", shortlist.map(color => color.id).join(","));
  return `/ai-hair-color-try-on?${params.toString()}`;
}
